var _defs, _circle, _g, _circle2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424.74 417.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #549cbe;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #596e85;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 199.85,
    cy: 200.23,
    r: 197.35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_8Y6zKT",
    "data-name": "8Y6zKT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.34,129.61c26.35,0,52.7-.02,79.04,0,10.48,0,13.71,3.26,13.72,13.73.02,29.51.02,59.02.02,88.53,0,9.46-3.64,13.2-13.19,13.21-53.47.04-106.95.04-160.42.01-9.16,0-12.89-3.74-12.9-12.95-.04-30.1-.04-60.2.01-90.3.01-8.41,3.82-12.19,12.32-12.21,27.13-.05,54.27-.02,81.4-.02ZM279.92,141.64H118.42v88.71h161.5v-88.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.32,261.66h-14.87c.01-.14.08-.26.08-.4v-14.91c0-2.88-2.34-5.21-5.22-5.21h-28.12c-2.88,0-5.21,2.33-5.21,5.21v14.91c0,.14.07.26.08.4h-14.87c-2.88,0-5.22,2.33-5.22,5.21v3.82c0,2.88,2.34,5.21,5.22,5.21h68.13c2.88,0,5.21-2.34,5.21-5.21v-3.82c0-2.88-2.33-5.21-5.21-5.21Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 353.81,
    cy: 345.62,
    r: 69.71
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.79,375.93h-69.96c-1.83,0-3.3-1.48-3.3-3.3v-12.2c0-1.82,1.48-3.3,3.3-3.3s3.3,1.48,3.3,3.3v8.9h63.35v-8.9c0-1.82,1.48-3.3,3.3-3.3s3.3,1.48,3.3,3.3v12.2c0,1.82-1.48,3.3-3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.81,355.01c-.66,0-1.31-.2-1.87-.58l-18.06-12.43c-1.5-1.03-1.88-3.09-.85-4.59,1.04-1.5,3.09-1.88,4.6-.85l12.88,8.86v-31.87c0-1.82,1.48-3.3,3.3-3.3s3.3,1.48,3.3,3.3v38.15c0,1.23-.68,2.35-1.77,2.92-.48.25-1.01.38-1.54.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.81,355.01c-1.05,0-2.08-.5-2.72-1.43-1.04-1.5-.65-3.56.85-4.59l18.05-12.43c1.51-1.04,3.56-.65,4.59.85,1.04,1.5.65,3.56-.85,4.59l-18.05,12.43c-.57.39-1.23.58-1.87.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktop);
export default __webpack_public_path__ + "static/media/Icon-Desktop.12ec3f05367866b8cb68f2ab7d6fecb7.svg";
export { ForwardRef as ReactComponent };